import { render, staticRenderFns } from "./AssetsComponent.vue?vue&type=template&id=42be67e7&scoped=true&"
import script from "./AssetsComponent.vue?vue&type=script&lang=js&"
export * from "./AssetsComponent.vue?vue&type=script&lang=js&"
import style0 from "./AssetsComponent.vue?vue&type=style&index=0&id=42be67e7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42be67e7",
  null
  
)

export default component.exports